import { Injectable } from '@angular/core';
import { of, from } from 'rxjs';
import { switchMap, map, take } from 'rxjs/operators';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { EnvironmentVariables } from '../../environment-variables';
import { AuthService, Unity4Claim } from '../../auth';
import { HttpClient } from '@angular/common/http';
import {
  CreateChallengeVm,
  ModalResponses,
  NotUsingMfaModalResponse,
} from '../models';
import { MfaChallengeModalComponent } from '../components';

@Injectable({
  providedIn: 'root',
})
export class MfaService {
  private mfaApi = `${this.environment.apiPath}/mfa`;

  constructor(
    private environment: EnvironmentVariables,
    private authSvc: AuthService,
    private http: HttpClient,
    private modalService: NgbModal
  ) {}

  createChallenge$() {
    return this.http.post<CreateChallengeVm>(this.mfaApi, {});
  }

  evaluateChallenge$(token: string, code: number) {
    type mfaEval = 'accept' | 'incorrect' | 'invalid';
    return this.http.put<mfaEval>(this.mfaApi, { token, code });
  }

  getToken$() {
    return this.authSvc.hasClaim$(Unity4Claim.MultiFactorAuth).pipe(
      take(1),
      switchMap((usingMfa) => {
        if (!usingMfa) {
          return of({ status: 'notusingmfa' } as NotUsingMfaModalResponse);
        }
        return this.createChallenge$().pipe(
          switchMap((vm) => {
            const modalRef = this.modalService.open(
              MfaChallengeModalComponent,
              {
                centered: true,
                backdrop: 'static',
              }
            );
            modalRef.componentInstance.token = vm.token;
            modalRef.componentInstance.mobile = vm.mobile;
            modalRef.componentInstance.email = vm.email;
            modalRef.componentInstance.sentTo = vm.sentTo;
            return modalRef.result;
          }),
          map((result) => result as ModalResponses)
        );
      })
    );
  }
}
